export interface B2CToken {
  account: AuthAccount
  idToken: string
  idTokenClaims: IdTokenClaims
  accessToken: string
  state: string
}

export interface DigitalFarmerAccountDictionary {
  [index: string]: DigitalFarmerAccount
}

export interface RelationshipOwner {
  fullName?: string
  email: string
  phone?: string
}

export interface AuthAccount {
  homeAccountId: string
  environment: string
  tenantId: string
  username: string
  localAccountId: string
  idTokenClaims: IdTokenClaims
  digitalFarmer?: {
    accounts: DigitalFarmerAccountDictionary
    contactFirstName: string
    contactLastName: string
    hasShareholderAccounts?: boolean
    isTfo: boolean
    selected: string
  }
}

export interface AccountDictionary {
  [index: string]: AuthAccount
}
export interface IdTokenClaims {
  ver: string
  iss: string
  sub: string
  aud: string
  exp: number
  nonce: string
  emails: string
  username: string
  iat: number
  auth_time: number
  given_name: string
  family_name: string
  tfp: string
  nbf: number
}

export interface AuthState {
  accounts: AccountDictionary
  status: string
  selectedAccountId: string | null
  atomicJWTToken: string | null
  token: string | null
}

export interface AccountAddress {
  city: string
  county: string
  dairySupplyNum: string
  fullAddress: string
  name: string
  ruralDeliveryNum: string
  street: string
  streetNumber: string
  zipCode: string
  recordId?: number
}

export interface Contact {
  name: string
  email: string
  phone: string
}

export interface DigitalFarmerAccount {
  /**
   * Name of farm / business on the account
   */
  accountName: string
  /**
   * Account number for this account
   */
  accountNumber: string

  /**
   * List of all known addresses for this account
   */
  addresses: AccountAddress[]

  /**
   * Managed accounts only
   */
  hasTfoAccess?: boolean

  /**
   * Managed accounts only
   */
  contact?: Contact | null

  /**
   * @deprecated The field should not be used
   */
  customerName?: string

  /**
   * Calculated on backend. Disables cart access
   */
  hasCheckoutAccess: boolean

  /**
   * Calculated on backend. Disables application access
   */
  hasShareholderAccess: boolean

  /**
   * Default store used for this account
   */
  homeBranchId: string

  /**
   * Default Port for nutrition promo
   */
  defaultPort: {
    name: string
    island: string
  }

  /**
   * Default selected account on first use
   */
  isDefault: boolean

  /**
   * Tfo contact details
   */
  relationshipOwner?: RelationshipOwner

  // Updated wih new Date() when account selected by setSelectedAccount
  lastViewedAt?: Date

  /**
   * Enforce customer refference
   */
  captureCustomerReference: boolean
}

export interface AccountsApiResponse {
  accounts: DigitalFarmerAccount[]
  contactFirstName: string
  contactLastName: string
}

export interface AtomicTokenApiResponse {
  token: string
}
